export enum TicketUrgency {
	Unknown = 0,
	MinorDecreaseProductivity = 1,
	MajorDecreaseProductivity = 2,
	CompletlyUnableToWork = 4,
}
